<template>
  <HeadlessTransitionRoot as="template" :show="isRevealed">
    <HeadlessDialog
      as="div"
      class="relative z-10"
      @close="cancel"
    >
      <HeadlessTransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-background-fg/30 transition-opacity"
        />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <HeadlessTransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <HeadlessDialogPanel
              class="relative overflow-hidden rounded-lg bg-background text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
            >
              <div class="text-center sm:text-left">
                <template v-if="title !== undefined">
                  <HeadlessDialogTitle
                    as="h3"
                    class="p-4 text-lg font-medium text-gray-900"
                  >
                    {{ title }}
                  </HeadlessDialogTitle>
                </template>
                <div
                  v-if="$slots.default || description"
                  class="border-y border-background-fg/12 bg-background-fg/5 p-4 leading-snug text-background-fg/87"
                >
                  <template v-if="$slots.default">
                    <slot></slot>
                  </template>
                  <p v-else>
                    {{ description }}
                  </p>
                </div>
              </div>

              <div class="p-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  class="inline-flex w-full justify-center rounded-md px-2 py-1 text-base text-background shadow-sm sm:ml-3"
                  :class="
                    isPositive ? 'bg-primary' : 'bg-error'
                  "
                  @click="confirm"
                >
                  {{ confirmLabel }}
                </button>
                <button
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md border border-background-fg/20 bg-background px-2 py-1 text-base text-background-fg/87 shadow-sm sm:mt-0"
                  @click="cancel"
                >
                  {{ cancelLabel }}
                </button>
              </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
    isPositive?: boolean
  }>(),
  {
    title: undefined,
    description: undefined,
    confirmLabel: "Yes",
    cancelLabel: "No",
  }
)
const { reveal, isRevealed, confirm, cancel } =
  useConfirmDialog()

defineExpose({
  reveal,
})
</script>
